import React from 'react';

const LoadingOverlay = ({label}) => {
  return (
    <div className="loading-overlay">
      <div className="loading-spinner"></div>
      <span>{label}</span>
    </div>
  );
};

export default LoadingOverlay;
